class HeroSplit {
  constructor() {
    this.selectors = {
      hero: '.smart-hero',
      heroImage: '.parallax-img-container img',
      heroAmbient: '.smart-hero__ambient-bg img',
      heroText: '.parallax-text-container'
    };

    this.init();
  }

  init() {
    this.cache();
    if (!this.hero) return;

    this.checkHeroContrast();
    this.bindScroll();
  }

  cache() {
    this.hero = document.querySelector(this.selectors.hero);
    this.heroImg = document.querySelector(this.selectors.heroImage);
    this.heroAmbient = document.querySelector(this.selectors.heroAmbient);
    this.heroTxt = document.querySelector(this.selectors.heroText);
  }

  bindScroll() {
    window.addEventListener('scroll', () => {
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY;

        if (!this.hero) return;

        if (scrollTop <= this.hero.offsetHeight) {
          if (this.heroImg) {
            this.heroImg.style.transform =
              `translate3d(0, ${scrollTop * 0.5}px, 0)`;
          }

          if (this.heroTxt) {
            this.heroTxt.style.transform =
              `translate3d(0, ${scrollTop * 0.15}px, 0)`;
          }

          if (this.heroAmbient) {
            this.heroAmbient.style.transform =
              `translate3d(0, ${scrollTop * 0.25}px, 0) scale(1.2) scaleX(-1)`;
          }
        }
      });
    });
  }

  checkHeroContrast() {
    if (!this.hero || !this.heroImg) return;

    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = this.heroImg.currentSrc || this.heroImg.src;

    if (img.complete) {
      this.analyzeImage(img);
    } else {
      img.onload = () => this.analyzeImage(img);
    }
  }

  analyzeImage(img) {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = 50;
      canvas.height = 50;

      ctx.drawImage(img, 0, 0, 50, 50);

      const data = ctx.getImageData(0, 0, 50, 50).data;

      let brightPixels = 0;
      const total = data.length / 4;

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i] / 255;
        const g = data[i + 1] / 255;
        const b = data[i + 2] / 255;

        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const l = (max + min) / 2;

        const d = max - min;
        const s = max === min ? 0 : d / (1 - Math.abs(2 * l - 1));

        if (l > 0.85 && s < 0.2) {
          brightPixels++;
        }
      }

      const ratio = (brightPixels / total) * 100;

      if (ratio > 25) {
        this.hero.classList.add('is-bright');
      } else {
        this.hero.classList.remove('is-bright');
      }
    } catch (e) {
      // fail silently
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeroSplit();
});